import { API_CONFIG } from "@/config/api";
import { reportUnauthorized } from "@/services/api";

function isAbsoluteUrl(path: string): boolean {
  return path.startsWith("http://") || path.startsWith("https://");
}

export function fileUrl(path: string): string {
  if (isAbsoluteUrl(path)) return path;
  return `${API_CONFIG.baseUrl}${path}`;
}

export function openFile(path: string): void {
  window.open(fileUrl(path), "_blank");
}

export async function downloadFile(path: string, name: string): Promise<void> {
  const resolved = fileUrl(path);
  const response = await fetch(resolved, {
    credentials: isAbsoluteUrl(path) ? "omit" : "include",
  });
  if (!response.ok) {
    // Absolute URLs are fetched without credentials and may be third-party.
    if (!isAbsoluteUrl(path)) reportUnauthorized(resolved, response.status);
    throw new Error(`Download failed: ${response.statusText}`);
  }
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = name;
  anchor.click();
  URL.revokeObjectURL(objectUrl);
}
